export default __webpack_public_path__ + "static/media/DSC_0793.a164c2b9.JPG";